export { AccordionsText } from "./accordions-text";
